import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ProductRequestDetail_Interface } from 'src/app/Interface/ProductRequestDetail_Interface';
import { ProductRequest_Interface } from 'src/app/Interface/ProductRequest_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductRequestService {

  constructor(private http: HttpClient) { }


  GetProductRequest(Token: String,
    PeriodDate:number,
    status:number,
    ProductName:String,
    StartSearchDate:String,
    EndSearchDate:String): Observable<Array<ProductRequest_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/ProductRequest?token=" + Token
      + "&PeriodDate="+PeriodDate
      + "&status="+status
      + "&ProductName="+ProductName
      + "&StartSearchDate="+StartSearchDate
      + "&EndSearchDate="+EndSearchDate
    ).pipe(
      map(data => {
        return data as Array<ProductRequest_Interface>
      })
    )
  }

  AddProductRequest(dsc: String,
    dsc_list: Array<String>,
    product_list: Array<any>,
    token: String): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {
      product_list:product_list,
      dsc: dsc,
      token: token,
      dsc_list: dsc_list,
      id: 0
    }
    return this.http.post(environment.BaseUrl + "Daro/ProductRequest/AddProductRequest", body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }


  GetSingleProductRequest(Token: String,id:number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/ProductRequest/GetSingleProductRequest?token=" + Token
    + "&id="+id).pipe(
      map(data => {
        return data as any
      })
    )
  }

}
